import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "./LoginPage";
import RouteErrorPage from './RouteErrorPage';
import Cookies from 'js-cookie';

// import useMe from './hooks/useMe';
// import useDataVerify from './dataHooks/useDataVerify';
// import useDataMe from './dataHooks/useDataMe';

const PrivateRoute = ({ element: Component, ...routeProps }) => {
  // const { isVerified, hasAppAccess } = useMe()
  // TODO: This should be eventually made more secure by being a token that will be sent to the backend
  // which can confirm its a cookie generated by us

  // Alternatively we may be able to use this same cookie, but make sure it is set to httpOnly / secure
  // This would mean however it cant be accessed by the javascript here below so we would need to make a dedicated API
  // endpoint to check if this cookie exists here and return true or false
  const isAuthorizedCookie = Cookies.get('isAuthorized');
  const loggedInUserId = Cookies.get('loggedInUserId');
  const adminPermissions = Cookies.get('adminPermissions');

  const hasAuth = (isAuthorizedCookie && isAuthorizedCookie === 'true');
  const hasUser = Boolean(loggedInUserId)
  const hasAdminPermissions = Boolean(adminPermissions)

  // future check: ( isVerified && hasAppAccess )
  // Ensure we have all require cookies set or foce redirect to the login page
  return (hasAuth && hasUser && hasAdminPermissions) ? <Component {...routeProps} /> : <LoginPage />;
};

const PublicRoute = ({ element: Component, ...routeProps }) => {
  return <Component {...routeProps} />;
};

export default ({
  routes = []
}) => {

  // const { getIsVerified } = useDataVerify()
  // const { fetchMe } = useDataMe()

  // const verifyLoader = async () => {
  //   const isVerified = await getIsVerified()
  //   const me = await fetchMe()
  //   return { ...me, isVerified }
  // };

  // const publicLoader  = async () => {
  //   const me = await fetchMe()
  //   return me;
  // }

  const parseRoute = (route) => {
    return route.map((routeObj) => {
      const {
        path,
        isPrivate,
      } = routeObj;
      const parsedRouteObj = { ...routeObj }
      if (path === '/') {
        parsedRouteObj.errorElement = <RouteErrorPage />;
      }

      if (isPrivate) {
        parsedRouteObj.element = <PrivateRoute {...routeObj} />;
        // parsedRouteObj.loader = verifyLoader;
      } else {
        parsedRouteObj.element = <PublicRoute {...routeObj} />;
        // parsedRouteObj.loader = publicLoader;
      }
      // parsedRouteObj.shouldRevalidate = () => true;
      
      return parsedRouteObj
    })
  }

  const router = createBrowserRouter(parseRoute(routes));

  return <RouterProvider router={router} />
}